import React from 'react';
import { Search, MapPin, Globe, ArrowLeft, Home } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 Number with SERP Theme */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 mb-4">
            404
          </h1>
          <div className="flex justify-center items-center space-x-2 mb-4">
            <Search className="w-6 h-6 text-blue-600 animate-pulse" />
            <span className="text-2xl font-semibold text-gray-800">Page Not Found</span>
            <Search className="w-6 h-6 text-purple-600 animate-pulse" />
          </div>
        </div>

        {/* Fun SERP-related message */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Oops! This page seems to have disappeared from our search results
          </h2>
          <p className="text-gray-600 mb-6 max-w-md mx-auto">
            It looks like this URL didn't rank well in our internal search engine. 
            Don't worry, even Google sometimes loses pages! 🕵️‍♂️
          </p>
          
          {/* Fun SERP-related stats */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-8 max-w-sm mx-auto">
            <div className="flex items-center justify-center space-x-4 mb-4">
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600">0</div>
                <div className="text-xs text-gray-500">Search Results</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-red-500">404</div>
                <div className="text-xs text-gray-500">Error Code</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-green-500">∞</div>
                <div className="text-xs text-gray-500">Patience</div>
              </div>
            </div>
            <p className="text-sm text-gray-600 italic">
              "This page has a 0% click-through rate" 😅
            </p>
          </div>
        </div>

        {/* Navigation options */}
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              <Home className="w-4 h-4 mr-2" />
              Go to Homepage
            </a>
            <button 
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </button>
          </div>
          
          {/* Fun search suggestion */}
          <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-sm text-yellow-800 mb-2">
              💡 <strong>Pro tip:</strong> Try using our SERP Checker to find what you're looking for!
            </p>
            <a 
              href="/#serp-checker"
              className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium"
            >
              <Search className="w-4 h-4 mr-1" />
              Check SERPs instead
            </a>
          </div>
        </div>

        {/* Fun footer */}
        <div className="mt-12 text-center">
          <div className="flex justify-center items-center space-x-2 mb-2">
            <Globe className="w-4 h-4 text-gray-400" />
            <span className="text-sm text-gray-500">404 errors found in 195+ countries</span>
            <MapPin className="w-4 h-4 text-gray-400" />
          </div>
          <p className="text-xs text-gray-400">
            This error page is SEO-optimized for maximum confusion 😉
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
